import { schema, types } from 'papr'

export const scheduledPostSchema = schema({
	author: types.objectId({ required: true }),
	draft: types.objectId({ required: true }),
	scheduledDate: types.date({ required: true }),
	scheduledDateTimeStamp: types.number({ required: true }),
	scheduledBy: types.objectId({ required: true }),
	publication: types.objectId({ required: true }),
})

export type ScheduledPostDocument = (typeof scheduledPostSchema)[0]
export type ScheduledPostSchemaOptions = (typeof scheduledPostSchema)[1]
